export function LetterIcon(props) {
  const { ...imgAttrs } = props;

  return (
    <img 
      {...imgAttrs}
      className={`profile-icon profile-icon__letter ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={"https://wvusstatic.com/illustrations/letter.svg?no-cache=true"} 
    />
  )
}

export default LetterIcon;